module.exports = __webpack_public_path__ + "static/logo-meiquer-jocotan-39528b8dc4d9929a1795aadb1323b2d2.png";